import { useInterval } from "providers";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const attendancePath = "/attendance";

export default function HeaderViewModel() {
  const interval = useInterval();
  const { loading, selectedItem, formatedDuration } = interval;
  const { handleChangeStatus } = interval;
  const { t } = useTranslation("components");
  const navigate = useNavigate();

  const handleToAnswer = useCallback(async () => {
    await handleChangeStatus().then(() => {
      const path = window.location.pathname;
      if (!path.includes(attendancePath)) navigate(`.${attendancePath}`);
    });
  }, [handleChangeStatus, navigate]);

  return { loading, selectedItem, formatedDuration, t, handleToAnswer };
}
